import { produce } from 'immer'
import {
  GET_CREDIT_CARD_SUCCESS,
  GET_CREDIT_CARDS_FAILURE,
  GET_CREDIT_CARDS_INIT,
  GET_CREDIT_CARDS_SUCCESS,
  GetCreditCardActions,
  GetCreditCardsActions,
} from 'src/redux/actions/data/creditCards.actions'

export interface CreditCardsFullPaginatedDataState {
  ids: string[]
  loading: boolean
  complete: boolean
  page?: number
  numPages?: number
  totalItems?: number
}

export const initialState: CreditCardsFullPaginatedDataState = {
  ids: [],
  loading: false,
  complete: false,
}

export type Actions = GetCreditCardsActions | GetCreditCardActions

const CreditCardsFullPaginatedDataReducer = (
  state = initialState,
  action: Actions,
): CreditCardsFullPaginatedDataState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_CREDIT_CARDS_INIT: {
        draft.loading = true
        return draft
      }

      case GET_CREDIT_CARDS_SUCCESS: {
        draft.loading = false
        draft.ids =
          action.payload.pagination.page === 0
            ? action.payload.creditCards.map((creditCard) => creditCard.id)
            : [
                ...draft.ids,
                ...action.payload.creditCards.map(
                  (creditCard) => creditCard.id,
                ),
              ]
        draft.complete =
          action.payload.pagination.page >=
          action.payload.pagination.numberOfPages - 1
        draft.page = action.payload.pagination.page
        draft.numPages = action.payload.pagination.numberOfPages
        draft.totalItems = action.payload.pagination.totalItems
        return draft
      }

      case GET_CREDIT_CARDS_FAILURE: {
        draft.loading = false
        draft.complete = true
        return draft
      }

      case GET_CREDIT_CARD_SUCCESS: {
        draft.ids = draft.ids.includes(action.payload.creditCard.id)
          ? draft.ids
          : [action.payload.creditCard.id, ...draft.ids]
        return draft
      }
    }
  })
}

export default CreditCardsFullPaginatedDataReducer
